import ILanguage from './ILanguage';

const en: ILanguage = {
    title: 'Language',
    portuguese: 'Portuguese',
    english: 'English',
    spanish: 'Spanish',
    prev: 'previous',
    next: 'next',
    send: 'Send',
    thankYouPageLeftTitle: 'Satisfaction survey',
    thankYouPageRightTitle: 'Thanks',
    thankYouPageText: 'Your opinion is very important to us!',
    loadingSplashScreenText: 'Loading...',
    of: 'of',
    developedBy: 'Developed by',
    requiredField: 'Required field',
    requiredQuestionLabel: '(required)',
    optionalQuestionLabel: '(optional)',
    staticClassForSandbox: 'Static classes for testing environment',
    parameterWarningLabel: 'Add parameter name and value at the end of URL like "&<name>=<value>"',
    AutoCompleteLoadingText: 'Loading, please wait',
    AutoCompleteNoOptionsText: 'No option available',
    AutoCompleteNoResultsText: 'No results found',
    AutoCompleteRetryTitle: 'Retry?',
    AutoCompleteSearchPromptText: 'Type to search',
    environmentSandbox: 'Test form, for viewing only',
    alreadyCompletedForm: 'You have already completed this form.',
    formUnavailable: 'This form is not available',
    form_unavailable_message: 'Oops! Survey not available at the moment',
    form_unavailable_description: 'This survey is no longer available at the moment.',
    expired_survey_message: 'Oops! Survey expired',
    expired_survey_description: 'The period to complete this survey has expired.',
    form_already_answered_message: 'This survey has already been completed',
    form_already_answered_description: 'It is not possible to complete this survey again.',
    like: 'Like',
    dislike: 'Dislike',
    scoreOption: 'Score {score}',
    formSubmitted: 'Form submitted.',
};

export default en;
